const RegisteredArticles = [
  "run-powershell-in-linux-with-docker",
  "hello-world",
  "cve-2019-17123"
]

export default RegisteredArticles;



// WEBPACK FOOTER //
// ./src/RegisteredArticles.js